import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { getConstants } from "./langUtils";
import { STRAPI_ASSETS_BASE_PATH } from "./utils";

const trainerPicIcon = `${STRAPI_ASSETS_BASE_PATH}trainer_pic_3a7fadc14a.jpg`;
function TrainerCard({ trainer, onOpenDialog, rangeDispUnit, locale }) {
  const { id, name, photoUrl, distance } = trainer;
  const displayUnit = rangeDispUnit === "KMS" ? "KM" : rangeDispUnit;

  useEffect(() => {
    const preLoadImage = new window.Image();
    preLoadImage.src = photoUrl || trainerPicIcon;
  }, [photoUrl]);

  return (
    <div className="col-md-4 mb-4 justify-content-center" key={id}>
      <div className="card d-flex flex-column">
        <div className="trainer-image">
          <img
            src={photoUrl || trainerPicIcon}
            alt="trainer_icon"
            priority={false}
            layout="responsive"
            width={140}
            height={140}
            objectFit="cover"
          />
        </div>
        <div className="card-body">
          <div className="trainer-title-distance">
            <h5 className="card-title text-center">{name}</h5>
            <p>
              {distance && (
                <span>
                  {distance} {displayUnit}
                </span>
              )}
            </p>
            <div className="trainer-send">
              <button
                className="btn btn-outline-dark trainer-btn-send"
                onClick={() => onOpenDialog(id,"trainers")}
                type="button"
              >
                {getConstants(locale)?.SEND}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

TrainerCard.propTypes = {
  trainer: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    photoUrl: PropTypes.string,
    distance: PropTypes.number,
  }).isRequired,
  onOpenDialog: PropTypes.func.isRequired,
  rangeDispUnit: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired,
};

export default TrainerCard;
